<template>
<div class="svg-container-outer">
    <div v-if="(selectedRoute != '')"  class="svg-container">
        <div class="manifest-text-container">
            <h3>Selected Route: {{selectedRoute}}</h3>
        </div>
    </div>
    <div v-if="manifestErrorMessage" class="manifest-error-container">
        <div class="manifest-error-content">
            <span class="manifest-error-icon">⚠️</span>
            <h3>{{ manifestErrorMessage }}</h3>
        </div>
    </div>
</div>
<div class="svg-container-outer">
    <LoadingData v-if="loadingOptimisation" :headerMessage="'Loading Optimization'"/>
    <LoadingData v-if="loadingManifestP2P" :headerMessage="'Loading Manifest P2P'"/>
    <div class="route-table-container">
        <h3 v-if="(selectedRoute != '')" class="manifest-header">Open Manifest</h3>
        <div v-if="(selectedRoute != '')" class="cutoff-date-container checkbox-container">
            <div>
                <label for="datetime" style="font-weight: bold;">Cutoff Date: </label>
                <input
                id="datetime"
                type="datetime-local"
                v-model="localDateTime"
                />  
            </div>
            <button class="show-manifest-button" @click="getManifestShipmentData()">Get Manifest Data</button>
        </div>
    </div>
    <div v-if="(selectedRoute != '') && (manifestMapData.length > 0) && (selectedRouteObject.openManifestAction != 'Optimized')"  class="svg-container">
        <div class="manifest-text-container">
            <h3>Route {{selectedRoute}}</h3>
        </div>
        <div class="manifest-text-container">
            <p>{{manifestMapData.length}} shipments on manifest.</p>
        </div>
        <div v-if="getManifestDataError == true" class="manifest-text-container">
            <p><span style="font-weight: bold">Error: </span> Shipments on manifest are missing external tracking number.</p>
        </div>
        <div class="manifest-text-container" v-if="manifestedSuccessfully"> 
            <h3>LREX Trip Sheet ID: {{manifestTripSheetID}}</h3>
        </div>
        <div class="manifest-text-container" v-if="manifestedSuccessfully">
            <h3>P2P Manifest ID: {{p2pManifestID}}</h3>
        </div>
        <div v-if="(selectedRoute != '') && (manifestMapData.length > 0)">
            <div v-if="!manifestedSuccessfully" class="manifest-text-container">
                <h3>Open Manifest</h3>
            </div>
           <manifest-shipment-table @refreshManifestTable="refreshManifestTable($event)" :cognitoUser="cognitoUser" :p2pManifestID="p2pManifestID" :manifestTripSheetID="manifestTripSheetID" :manifestShipmentTableData="manifestMapData"/> 
        </div>
        <div class="manifest-button-container" v-if="(p2pManifestSuccess == false) && (p2pManfifestError == false) && (getManifestDataError == false)">
            <button class="show-manifest-button" @click="manifestShipmentsP2P()">Manifest P2P</button>
        </div>
        <div class="manifest-button-container">
            <button style="margin-top: 5px" class="refresh-button" @click="getManifestShipmentData()">Refresh</button>
        </div>
    </div>
        <div v-if="(selectedRoute != '') && (manifestMapData.length > 0) && (selectedRouteObject.openManifestAction == 'Optimized')"  class="svg-container">
            <div class="svg-inner-container">
                <p>Delivery</p>
                <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="15" height="25" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <circle cx="12" cy="12" r="10" fill="#fff"/>
                    <path stroke="#000" stroke-width="1" fill="#32ccfe" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                </svg>
            </div>
            <div class="svg-inner-container">
                <p>Pickup</p>
                <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="15" height="25" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <circle cx="12" cy="12" r="10" fill="#fff"/>
                    <path stroke="#000" stroke-width="1" fill="#33f18a" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                </svg>
            </div>
            <div class="svg-inner-container">
                <p>Priority</p>
                <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="15" height="25" viewBox="0 0 24 32">
                    <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                    <circle cx="12" cy="12" r="10" fill="#fff"/>
                    <path stroke="#000" stroke-width="1" fill="#fe804d" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                </svg>
            </div>
        </div>
        <div class="optimize-button-container">
            <div class="optimize-button-container-inner">
                <div v-if="(selectedRoute != '') && (manifestMapData.length > 0) && (selectedRouteObject.openManifestAction == 'Optimized')" class="button-container">
                    <button class="refresh-button" @click="refreshMap()">Refresh</button>
                </div>
                <div v-if="(selectedRoute != '') && (manifestMapData.length > 0) && (selectedRouteObject.openManifestAction == 'Optimized')" class="button-container">
                    <button class="show-manifest-button" @click="showFullManifest();">Show Full Manifest</button>
                </div>
                <div v-if="(selectedRoute != '') && (manifestMapData.length > 0) && (shipmentsFoundNotReady == false) && (shipmentsNeedReGeoCode == false) && (selectedRouteObject.openManifestAction == 'Optimized')" class="button-container">
                    <button @click="optimiseManifest()" class="optimize-manifest-button">Optimize</button>
                </div> 
            </div>
            
            <div class="optimize-button-container">
                <div class="optimize-button-container-inner">
                    <div v-if="(selectedRoute != '') && (manifestMapData.length > 0) && (selectedRouteObject.openManifestAction == 'Optimized')" class="button-container-checkbox">
                        <label for="ignoreStatus">Ignore Shipment Status</label>
                        <input type="checkbox" name="ignoreStatus" id="" @change="ignoreShipmentStatusOptimizeToggle()">
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    <div class="title-header-container" v-if="(shipmentsNeedReGeoCode) && (showAllManifestData == false)">
        <h3>Verify and Correct Shipment Coordinates</h3>
        <p>{{shipmentsToReGeoCode.length}} shipments need to be corrected.</p>
        <div class="scrollable-container">
            <div v-if="showAllShipmentsToReGeoCode">
                <div class="scrollable-container-inner" v-for="manifestShipment in shipmentsToReGeoCode" :key="manifestShipment.shipmentID">
                    <h3 class="scrollable-h3" @click="highlightShipment(manifestShipment.shipmentID)">{{ manifestShipment.shipmentID }}</h3>
                    <p>{{manifestShipment.address.address1}}, {{manifestShipment.address.city}} {{manifestShipment.address.state}} {{manifestShipment.address.zipCode}}</p>
                </div>
            </div>
            <div v-if="(shipmentsToReGeoCode.length) && (showAllShipmentsToReGeoCode == false)" class="scrollable-container-inner">
                <h3 class="scrollable-h3" @click="highlightShipment(currentShipment.shipmentID)">{{ currentShipment.shipmentID }}</h3>
                <p>{{ currentShipment.address.address1 }}, {{ currentShipment.address.city }} {{ currentShipment.address.state }} {{ currentShipment.address.zipCode }}</p>
            </div>
        </div>
        <div class="navigation-buttons">
            <div class="left-buttons">
                <button @click="prevShipment" :disabled="currentIndex === 0">Previous</button>
                <button @click="nextShipment" :disabled="currentIndex === shipmentsToReGeoCode.length - 1">Next</button>
            </div>
            <button @click="showAllShipmentsToReGeoCode = !showAllShipmentsToReGeoCode" class="right-button">
                <span v-if="!showAllShipmentsToReGeoCode">Show</span>
                <span v-if="showAllShipmentsToReGeoCode">Hide</span> All
            </button>
        </div>
    </div>
    <div class="title-header-container" v-if="(shipmentsFoundNotReady) && (shipmentsToReGeoCode.length == 0)">
        <h3>Shipments Not Ready</h3>
        <p>{{shipmentsNotReady.length}} shipments are not ready.</p>
        <div class="scrollable-container">
            <div v-if="showAllShipmentsNotReady">
                <div class="scrollable-container-inner" v-for="manifestShipment in shipmentsNotReady" :key="manifestShipment.shipmentID">
                    <h3 class="scrollable-h3" @click="highlightShipment(manifestShipment.shipmentID)">{{ manifestShipment.shipmentID }}</h3>
                    <p>{{manifestShipment.address.companyName || ""}}</p>
                    <p>{{manifestShipment.address.address1}}, {{manifestShipment.address.city}} {{manifestShipment.address.state}} {{manifestShipment.address.zipCode}}</p>
                </div>
            </div>
            <div v-if="(shipmentsNotReady.length) && (showAllShipmentsNotReady == false)" class="scrollable-container-inner">
                <h3 class="scrollable-h3" @click="highlightShipment(currentShipmentNotReady.shipmentID)">{{ currentShipmentNotReady.shipmentID }}</h3>
                <p>{{currentShipmentNotReady.address.companyName || ""}}</p>
                <p>{{ currentShipmentNotReady.address.address1 }}, {{ currentShipmentNotReady.address.city }} {{ currentShipmentNotReady.address.state }} {{ currentShipmentNotReady.address.zipCode }}</p>
            </div>
        </div>
        <div class="navigation-buttons">
            <div class="left-buttons">
                <button @click="prevShipmentNotReady" :disabled="currentIndexNotReady === 0">Previous</button>
                <button @click="nextShipmentNotReady" :disabled="currentIndexNotReady === shipmentsNotReady.length - 1">Next</button>
            </div>
            <button @click="showAllShipmentsNotReady = !showAllShipmentsNotReady" class="right-button">
                <span v-if="!showAllShipmentsNotReady">Show</span>
                <span v-if="showAllShipmentsNotReady">Hide</span> All
            </button>
        </div>
    </div>
    <div class="title-header-container" v-if="(shipmentsNeedReGeoCode == false) && (selectedRoute != '') && (manifestMapData.length > 0) && (selectedRouteObject.openManifestAction == 'Optimized')">
        <h3>Open Manifest Route {{selectedRoute}}</h3>
        <p>{{manifestMapData.length}} shipments on manifest.</p>
    </div>
    <div class="title-header-container" v-if="(shipmentsNeedReGeoCode == true) && (showAllManifestData == true) && (selectedRoute != '') && (manifestMapData.length > 0) && (selectedRouteObject.openManifestAction == 'Optimized')">
        <h3>Open Manifest Route {{selectedRoute}}</h3>
        <p>{{manifestMapData.length}} shipments on manifest.</p>
        <p>{{shipmentsToReGeoCode.length}} shipments need to be corrected.</p>
        <div class="scrollable-container">
            <div v-if="showAllShipmentsToReGeoCode">
                <div class="scrollable-container-inner" v-for="manifestShipment in shipmentsToReGeoCode" :key="manifestShipment.shipmentID">
                    <h3>{{ manifestShipment.shipmentID }}</h3>
                    <p>{{manifestShipment.address.address1}}, {{manifestShipment.address.city}} {{manifestShipment.address.state}} {{manifestShipment.address.zipCode}}</p>
                </div>
            </div>
            <div v-if="(shipmentsToReGeoCode.length) && (showAllShipmentsToReGeoCode == false)" class="scrollable-container-inner">
                <h3>{{ currentShipment.shipmentID }}</h3>
                <p>{{ currentShipment.address.address1 }}, {{ currentShipment.address.city }} {{ currentShipment.address.state }} {{ currentShipment.address.zipCode }}</p>
            </div>
        </div>
        <div class="navigation-buttons">
            <div class="left-buttons">
                <button @click="prevShipment" :disabled="currentIndex === 0">Previous</button>
                <button @click="nextShipment" :disabled="currentIndex === shipmentsToReGeoCode.length - 1">Next</button>
            </div>
            <button @click="showAllShipmentsToReGeoCode = !showAllShipmentsToReGeoCode" class="right-button">
                <span v-if="!showAllShipmentsToReGeoCode">Show</span>
                <span v-if="showAllShipmentsToReGeoCode">Hide</span> All
            </button>
        </div>
    </div>
    <div v-if="(selectedRoute != '') && (manifestMapData.length > 0) && (selectedRouteObject.openManifestAction == 'Optimized')" class="input-container">
        <div class="aws-search-address-container">
            <AWSAutoComplete @GetSelectedAddressData="GetSelectedAddressData($event)" @customAddressToggle="customAddressToggle($event)" :placeHolder="placeHolder" />
            <button v-if="addressSuggestionLocation" class="clear-address-button" @click="clearAddressSuggestion()">Clear Address Pin</button>
        </div>
    </div>
  <div v-show="(selectedRoute != '') && (manifestMapData.length > 0)" class="map-search-wrapper">
    <div ref="awsmap" id="map" />
    <div class="map-search-box">
      <input
        type="text"
        class="map-search-input"
        v-model="shipmentSearchQuery"
        placeholder="Search shipments by ID, company, or address"
      />
      <div class="map-search-results" v-if="shipmentSearchResults.length > 0">
        <div
          class="map-search-result"
          v-for="shipment in shipmentSearchResults"
          :key="shipment.shipmentID"
          @click="selectSearchResult(shipment)"
        >
          <span class="map-search-result-company">{{ shipment.address && shipment.address.companyName ? shipment.address.companyName : shipment.shipmentID }}</span>
          <span class="map-search-result-address" v-if="shipment.address">{{ shipment.address.address1 }}, {{ shipment.address.city }}, {{ shipment.address.state }} {{ shipment.address.zipCode }}</span>
          <span class="map-search-result-id">ID: {{ shipment.shipmentID }}</span>
        </div>
      </div>
      <div class="map-search-results" v-else-if="shipmentSearchQuery.trim().length >= 2">
        <div class="map-search-no-result">No shipments found</div>
      </div>
    </div>
  </div>
  <loading-skeleton :loadingHeight="'50vh'" v-if="loadingManifestData"/>
  <shipment-info v-if="toggleTrackShipment" @refreshOpenManifest="refreshOpenManifest($event)" @closeShipmentInfo="closeShipmentInfo($event)" :cognitoUser="cognitoUser" :userData="userData" :trackShipmentID="popUpSelectedShipmentID"/>

    <div class="svg-container" v-show="(selectedRoute != '') && (manifestMapData.length > 0) && (selectedRouteObject.openManifestAction == 'Optimized')">
        <div class="manifest-text-container">
            <h3>Open Manifest</h3>
        </div>
        <div class="manifest-text-container">
            <h3>Shipment Count: {{manifestTableTemporaryData.length}}</h3>
        </div>

        <select required name="Delivery Type" id="Delivery Type" v-model="manifestTableFilterValue" @change="filterManifestMapData">
            <option value="Priority">Priority</option>
            <option value="Delivery">Delivery</option>
            <option value="Pickup">Pickup</option>
            <option value="Not Ready">Not Ready</option>
            <option value="Ready">Ready</option>
            <option value="All">All</option>
        </select>
        
        <manifest-shipment-table @closeShipmentInfoRefresh="closeShipmentInfoRefresh($event)" @refreshManifestTable="refreshManifestTable($event)" :cognitoUser="cognitoUser" :p2pManifestID="p2pManifestID" :userData="userData" :manifestTripSheetID="manifestTripSheetID" :manifestShipmentTableData="manifestTableTemporaryData"/> 
    </div>

    <div v-if="(selectedRoute != '') && (manifestMapData.length > 0) && (selectedRouteObject.manifestStatus == 'Optimization Failed')" class="data-container-main">
        <div class="table-container">
            <div class="manifest-text-container">
                <h3>Failed Optimized Manifest</h3>
            </div>
            <manifest-waypoint-table @closeShipmentInfoRefresh="closeShipmentInfoRefresh($event)" :cognitoUser="user" :userData="userData" :filterByRouteCode="selectedRoute"/>
        </div>
    </div>

    <div v-if="(selectedRoute != '') && (manifestMapData.length > 0) && (selectedRouteObject.openManifestAction == 'Optimized')" class="data-container-main">
        <div class="table-container">
            <div class="manifest-text-container">
                <h3>Queued Activities</h3>
            </div>
            <queued-activities-table @refreshAfterVoid="refreshAfterVoid($event)" :selectedAccountNo="selectedAccountNo" :cognitoUser="user" :selectedShipment="selectedShipment" :selectedDates="selectedDates" :jwtToken="jwtToken" :userData="userData" :filterByRoute="selectedRoute"/>
        </div>
    </div>

  <div v-if="showDragAddressSuggestion" class="alert-container">
      <div class="inner-container">
          <div class="text-container">
            <div class="header-outer-container">
                <div class="header-container">
                    <svg style="width: 15px;
                    height: 15px;
                    padding-right: 5px;" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.67 328.54" data-v-13454f0d=""><g id="_Ñëîé_1" data-name="Ñëîé 1" data-v-13454f0d=""><g data-v-13454f0d=""><g data-v-13454f0d=""><polyline class="cls-2-alt" points="213.95 310.25 213.95 280.72 192.99 240.34 66.07 240.34 45.11 284.23 45.11 310.25" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="48.63" y1="284.23" x2="213.95" y2="284.23" data-v-13454f0d=""></line><polyline class="cls-2-alt" points="150.64 284.23 150.64 323.54 129.53 314.13 108.43 323.54 108.43 284.23" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="115.46" y1="240.34" x2="108.43" y2="284.23" data-v-13454f0d=""></line><line class="cls-2-alt" x1="150.64" y1="284.23" x2="143.6" y2="240.34" data-v-13454f0d=""></line></g><path class="cls-2" d="M5,263.23l4.07-31.12c1.49-11.39,9.48-20.87,20.45-24.26l41.72-12.89c4.68-1.45,9.78-.46,13.58,2.62h0c23.9,19.38,58.11,19.38,82.01,0h0c3.81-3.09,8.9-4.07,13.58-2.62l41.72,12.89c10.97,3.39,18.97,12.87,20.45,24.26l4.07,31.12" data-v-13454f0d=""></path><path class="cls-2" d="M179.67,133.69v1.49c0,17.17-9.99,32.77-25.58,39.95l-16.31,7.52c-7.79,3.59-16.76,3.59-24.54,0l-16.31-7.52c-15.59-7.18-25.58-22.78-25.58-39.95v-1.49" data-v-13454f0d=""></path><path class="cls-2" d="M66.66,77.38l2.08-34.12c.68-11.22,7.8-21.02,18.25-25.15l28.02-11.08c6.83-2.7,14.44-2.7,21.28,0l28.02,11.08c10.45,4.13,17.56,13.94,18.25,25.15l2.08,34.12" data-v-13454f0d=""></path><path class="cls-2" d="M182.17,75.94l-.69-.59c-31.61-27.16-78.16-27.68-110.37-1.23l-1.41,1.16c-5.33,4.37-6.62,12-3.03,17.89l8.7,14.27h0c30.19-23.72,72.69-23.72,102.89,0h0s3.95-8.06,7.32-14.94c2.77-5.66,1.38-12.46-3.4-16.56Z" data-v-13454f0d=""></path><path class="cls-2" d="M57.76,116.69l-.15,.9c-1.37,8.44,5.15,16.11,13.7,16.11h.03" data-v-13454f0d=""></path><path class="cls-2" d="M193.24,116.69l.15,.9c1.37,8.44-5.15,16.11-13.7,16.11h0" data-v-13454f0d=""></path></g></g></svg>
                    <h3 style="margin: 0">{{dragSelectedShipmentID}}</h3>
                </div>  
            </div>
            
            <!-- <p style="font-weight: bold;">Update geocode to:</p>
            <p>Latitude: {{autoCompleteDataGeoCode[1]}}</p>
            <p>Longitude: {{autoCompleteDataGeoCode[0]}}</p>
            <button class="cancel-button" @click="closeAddressSuggestion(); mapCreate();">Cancel and Reset Marker</button>
            <button class="cancel-button" @click="closeAddressSuggestion();">Cancel and Continue Dragging Marker</button>
            <button class="update-button" @click="updateShipmentDataGeoCode();">Update GeoCode</button> -->
            <div class="geo-card">
                <p class="geo-title">Update geocode</p>

                <p class="geo-address" v-if="dragSnappedToSuggestion && addressSuggestionGeoCode.address1">
                    {{ addressSuggestionGeoCode.address1 }}, {{ addressSuggestionGeoCode.city }}, {{ addressSuggestionGeoCode.state }} {{ addressSuggestionGeoCode.zipCode }}
                </p>

                <div class="geo-values">
                    <div class="geo-row">
                        <span class="label">Latitude</span>
                        <span class="value">{{ autoCompleteDataGeoCode[1] }}</span>
                    </div>
                    <div class="geo-row">
                        <span class="label">Longitude</span>
                        <span class="value">{{ autoCompleteDataGeoCode[0] }}</span>
                    </div>
                </div>

                <div class="geo-actions">
                    <button class="btn secondary" @click="closeAddressSuggestion(); mapCreate();">
                        Cancel & Reset Marker
                    </button>
                    <button class="btn secondary" @click="closeAddressSuggestion();">
                        Keep Dragging
                    </button>
                    <button class="btn primary" @click="updateShipmentDataGeoCode();">
                        Update GeoCode
                    </button>
                </div>
            </div>
            <loading-charts v-if="loadingData"/>
          </div>
      </div>
  </div>
  <AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/> 
</template>

<script>
import { Auth, Signer, API } from 'aws-amplify'
import Location from "aws-sdk/clients/location";
import maplibregl from 'maplibre-gl'
import AWS from '../../aws-exports'
import 'maplibre-gl/dist/maplibre-gl.css';
import AlertUser from '../Popups/AlertUser.vue';
import ShipmentInfo from '../ShipmentDashboard/ShipmentInfo.vue'
import LoadingSkeleton from '../ShipmentDashboard/LoadingSkeleton.vue'
import { updateShipmentData } from '../../graphql/mutations'
import LoadingCharts from '../ShipmentDashboard/LoadingCharts.vue';
// import AWSAutoComplete from '../AWSLocation/AddressAutoComplete.vue';
import AWSAutoComplete from '../AWSLocation/EsriAddressAutoComplete.vue';
import LoadingData from '../../components/Popups/LoadingData.vue';
import ManifestShipmentTable from '../ShipmentDashboard/ManifestDashboard/ManifestShipmentTable.vue'
import QueuedActivitiesTable from '../ShipmentDashboard/QueuedActivitiesDashboard/QueuedActivitiesTable.vue'
import ManifestWaypointTable from '../ShipmentDashboard/ManifestDashboard/ManifestWaypointTable.vue';


export default {
    data(){
        return{
            toggleTrackShipment: false,
            showDragAddressSuggestion: false,
            autoCompleteData: [],
            autoCompleteDataFromText: [],
            autoCompleteDataGeoCode: [],
            credentials: null,
            user: {},
            mapCenter: [],
            popUpSelectedShipmentID: "",
            manifestMapData: [],
            shipmentsToReGeoCode: [],
            shipmentsNotReady: [],
            shipmentsNeedReGeoCode: false,
            shipmentsFoundNotReady: false,
            showAllManifestData: false,
            selectedRoute: "",
            toggleAlertBox: false,
            alertMessage: "",
            loadingManifestData: false,
            dragSelectedShipmentID: "",
            dragSelectedIsDelivery: false,
            dragSelectedIsPickup: false,
            routeTableData: [],
            shipmentData: {},
            loadingData: false,
            addressSuggestionLocation: false,
            addressSuggestionGeoCode: {
                latitude: 0,
                longitude: 0,
                address1: "",
                street: "",
                city: "", 
                zipCode: ""
            },
            addressSuggestionMarkerAdded: false,
            dragSnappedToSuggestion: false,
            placeHolder: "Search an address to drop a reference pin",
            currentIndex: 0,
            currentIndexNotReady: 0,
            showAllShipmentsToReGeoCode: false,
            showAllShipmentsNotReady: false,
            selectedRouteObject: {},
            tripShipments: [],
            loadingManifestP2P: false,
            p2pManifestSuccess: false,
            p2pManifestID: null,
            manifestTripSheetID: null,
            p2pManfifestError: false,
            isoDateTime: "",
            localDateTime: "",
            getManifestDataError: false,
            manifestedSuccessfully: false,
            loadingOptimisation: false,
            shipmentMarkers: {},
            mapInstance: null,
            manifestTableFilterValue: "",
            manifestTableTemporaryData: [],
            refreshPage: false,
            manifestErrorMessage: "",
            routeDataForOptimize: {},
            shipmentSearchQuery: ""
        }
    },
    components:{
        ShipmentInfo,
        AlertUser,
        LoadingSkeleton,
        LoadingCharts,
        AWSAutoComplete,
        LoadingData,
        ManifestShipmentTable,
        QueuedActivitiesTable,
        ManifestWaypointTable
    },
    props: ['userData', 'cognitoUser', "routeData"],
    watch:{
        async 'routeData'(){
            this.selectedRoute = this.routeData.routeCode;
            this.selectedRouteObject = this.routeData;
            const now = new Date();
            if (this.routeData.fromRedirect && this.routeData.routeCode === "SMD") {
                // Arrived via the Same Day initiate redirect (routecode query param) for the SMD
                // route. The just-created shipment's addedOn can be ahead of the (possibly slow)
                // local clock, so a small +N minute buffer isn't reliable. Use end-of-day as the
                // cutoff so the shipment is always captured. Everything else keeps +1 min.
                now.setHours(23, 59, 59, 0);
            } else {
                now.setMinutes(now.getMinutes() + 1);
            }
            const formattedDateTime = now.getFullYear() + "-" +
                String(now.getMonth() + 1).padStart(2, "0") + "-" +
                String(now.getDate()).padStart(2, "0") + "T" +
                String(now.getHours()).padStart(2, "0") + ":" +
                String(now.getMinutes()).padStart(2, "0");

            this.localDateTime = formattedDateTime;
            await this.refreshMap()
        }
    },
    mounted: async function () {
        this.credentials = await Auth.currentCredentials()
        Auth.currentAuthenticatedUser().then(user => {
            this.user = user;
            // this.listRouteData();
        }).catch(error => {
          if(error){
            this.$router.push('Login');
            Auth.signOut({global: false})
          }
        });
        
        this.selectedRoute = this.routeData.routeCode;
        this.selectedRouteObject = this.routeData;
        const now = new Date();
        if (this.routeData.fromRedirect && this.routeData.routeCode === "SMD") {
            // Arrived via the Same Day initiate redirect (routecode query param) for the SMD
            // route. The just-created shipment's addedOn can be ahead of the (possibly slow)
            // local clock, so a small +N minute buffer isn't reliable. Use end-of-day as the
            // cutoff so the shipment is always captured. Everything else keeps +1 min.
            now.setHours(23, 59, 59, 0);
        } else {
            now.setMinutes(now.getMinutes() + 1);
        }
        const formattedDateTime = now.getFullYear() + "-" +
            String(now.getMonth() + 1).padStart(2, "0") + "-" +
            String(now.getDate()).padStart(2, "0") + "T" +
            String(now.getHours()).padStart(2, "0") + ":" +
            String(now.getMinutes()).padStart(2, "0");

        this.localDateTime = formattedDateTime;
        console.log("ROUTE DATA :", this.routeData)

        // Auto-load the manifest data/map when the component mounts with a route already
        // selected (e.g. the SAMEDAY route auto-selected after Same Day initiate).
        if(this.routeData && this.routeData.routeCode){
            await this.refreshMap();
        }
    },
    computed:{
        currentShipment() {
            return this.shipmentsToReGeoCode[this.currentIndex];
        },
        currentShipmentNotReady(){
            return this.shipmentsNotReady[this.currentIndexNotReady];
        },
        shipmentSearchResults(){
            const query = this.shipmentSearchQuery.trim().toLowerCase();
            if(query.length < 2) return [];
            return this.manifestMapData.filter(shipment => {
                const address = shipment.address || {};
                const fields = [
                    shipment.shipmentID,
                    address.companyName,
                    address.address1,
                    address.address2,
                    address.city,
                    address.state,
                    address.zipCode
                ];
                return fields.some(field => field && field.toString().toLowerCase().includes(query));
            }).slice(0, 10);
        }
    },
    unmounted(){
        //Reset hash allow map to adjust to address changes
        window.location.hash = ""
        console.log("UNMOUNTED")
        this.mapInstance = null;
    },
    methods:{
        async getManifestWaypointData(){
            this.loadingManifestData = true;

            let input = {
                input:{
                    route: this.selectedRoute
                }
            }

            let queryManifestWaypoint = `mutation queryManifestWaypoint($input: queryManifestWaypointInput!) {
                queryManifestWaypoint(input: $input) {
                    route
                    stop
                    error
                    waypoint
                }
            }`

            try {
                let queryManifestWaypointData = await API.graphql({
                    query: queryManifestWaypoint,
                    variables: input,
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });

                const manifestData = queryManifestWaypointData.data.queryManifestWaypoint;

                console.log(manifestData)

                const errorItem = manifestData.find(item => item.waypoint === "*");

                if (errorItem?.error) {
                    // this.toggleAlertBox = true;
                    // this.alertMessage = errorItem.error;
                    this.manifestErrorMessage = errorItem.error;
                    this.loadingManifestData = false;
                    return;
                }

                this.loadingManifestData = false;
            } catch (e) {
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting manifest error message.";
                this.loadingManifestData = false;
            }
        },
        async ignoreShipmentStatusOptimizeToggle(){
            if(this.shipmentsNeedReGeoCode == false && this.shipmentsFoundNotReady == false){
                await this.getManifestShipmentData();
                return
            }

            this.shipmentsNeedReGeoCode = false;
            this.shipmentsFoundNotReady = false;
        },
        async filterManifestMapData(){
            console.log(this.manifestTableFilterValue)
            console.log(this.manifestMapData)
            this.manifestTableTemporaryData = this.manifestMapData;
            
            if(this.manifestTableFilterValue == "Delivery"){
                this.manifestTableTemporaryData = this.manifestMapData.filter(item => (item?.isDelivery === true && !item?.isPriority));
            }else if(this.manifestTableFilterValue == "Priority"){
                this.manifestTableTemporaryData = this.manifestMapData.filter(item => item?.isPriority === true);
            }else if(this.manifestTableFilterValue == "Pickup"){
                this.manifestTableTemporaryData = this.manifestMapData.filter(item => item?.isDelivery === false);
            }else if(this.manifestTableFilterValue == "Not Ready"){
                this.manifestTableTemporaryData = this.manifestMapData.filter(item => item?.status === "NotReady");
            }else if(this.manifestTableFilterValue == "Ready"){
                this.manifestTableTemporaryData = this.manifestMapData.filter(item => item?.status === "Open" || item?.status === "Optimized");
            }else if(this.manifestTableFilterValue == "All"){
                this.manifestTableTemporaryData = this.manifestMapData;
            }
        },
        async manifestShipmentsP2P(){
            this.loadingManifestP2P = true;
            this.manifestedSuccessfully = false;
            try {
                let tripSheetID = await this.manifestCreateTripFunc();
                this.manifestTripSheetID = tripSheetID;
                await this.listTripShipmentsFunc(tripSheetID);
                console.log("Trip Shipments: ", this.tripShipments)
                const shipmentIds = this.tripShipments.map(shipment => shipment.shipmentID);
                await this.manifestParcelsP2P(tripSheetID, shipmentIds);
                this.loadingManifestP2P = false;
                this.manifestedSuccessfully = true;
            } catch (error) {
                console.log(error);
                this.toggleAlertBox = true;
                this.alertMessage = "Error manifesting parcels P2P.";
                this.loadingManifestP2P = false;
            }
        },
        async manifestParcelsP2P(tripSheetID, shipmentIds){
            this.p2pManifestSuccess = false;
            this.p2pManfifestError = false;
            let input = {
                input:{
                    tripSheetID: tripSheetID.toString(),
                    shipmentIDArray: shipmentIds
                }
            }
            let manifestParcelP2P = `mutation manifestParcelP2P($input: manifestParcelP2PInput!){
            manifestParcelP2P(input: $input) {
                    status
                    ManifestID
                    Document
                    errors
                }
            }
            `

            try{
                let manifestParcelP2PData = await API.graphql({
                query:  manifestParcelP2P,
                variables: input,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                console.log("manifestParcelP2P Data: ", manifestParcelP2PData);
                if(manifestParcelP2PData.data.manifestParcelP2P.status == "error"){
                    this.toggleAlertBox = true;
                    this.alertMessage = "P2P: " + manifestParcelP2PData.data.manifestParcelP2P.errors;
                    this.p2pManfifestError = true;
                    throw new Error("Manifest P2P Failed: ", manifestParcelP2PData.data.manifestParcelP2P.errors)
                }else if(manifestParcelP2PData.data.manifestParcelP2P.status == "success"){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Successfully manifested P2P Parcels.";
                    this.p2pManifestSuccess = true;
                    this.p2pManifestID = manifestParcelP2PData.data.manifestParcelP2P.ManifestID;
                }
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting manifestCreateTrip data"
                }
                throw new Error("Manifest P2P Failed: ", e)
            }
        },
        async listTripShipmentsFunc(tripSheetID) {
            this.tripShipments = [];
            let graphqlQuery = `query listTripShipments($nextToken: String, $tripSheetID: String) {
                listTripShipments(nextToken: $nextToken, tripSheetID: $tripSheetID) {
                    items {
                        shipmentID
                        status
                        tripSheetID
                    }
                    nextToken
                }
            }`;

            try {
                let allTripShipments = [];
                let nextToken = null;

                do {
                    let response = await API.graphql({
                        query: graphqlQuery,
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                        variables: { nextToken, tripSheetID }
                    });

                    const data = response.data.listTripShipments;
                    allTripShipments = [...allTripShipments, ...data.items];
                    nextToken = data.nextToken;

                } while (nextToken); 

                this.tripShipments = allTripShipments;
            } catch (e) {
                console.log(e);
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting trip shipments.";
                throw new Error("Listing Trip Shipments Failed: ", e)
            }
        },
        async manifestCreateTripFunc(){
            this.manifestTripSheetID = null;
            let manifestsToDespatchValue;
            if(this.selectedRouteObject.openManifestAction == "P2PManifest"){
                manifestsToDespatchValue = "Open"
            }
            
            let input = {
                input:{
                    routeId: this.selectedRouteObject.routeId,
                    manifestsToDespatch: [manifestsToDespatchValue]
                }
            }
            let manifestCreateTrip = `mutation manifestCreateTrip{
            manifestCreateTrip(input: {routeId: ${this.selectedRouteObject.routeId}, manifestsToDespatch: ["${manifestsToDespatchValue}"]}) {
                    tripSheetID
                }
            }
            `

            try{
                let manifestCreateTripData = await API.graphql({
                query:  manifestCreateTrip,
                variables: input,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                console.log("manifestCreateTrip Data: ", manifestCreateTripData.data.manifestCreateTrip.tripSheetID);
                return manifestCreateTripData.data.manifestCreateTrip.tripSheetID;
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting manifestCreateTrip data"
                }
                throw new Error("Manifest Create Trip Failed: ", e)
            }
        },
        async selectRouteCode(event){
            this.selectedRoute = "";
            this.isoDateTime = "";
            this.manifestMapData = []
            console.log(event)
            this.selectedRoute = event.routeCode;
        },
        prevShipment() {
            if (this.currentIndex > 0) {
                this.currentIndex--;
            }
        },
        nextShipment() {
            if (this.currentIndex < this.shipmentsToReGeoCode.length - 1) {
                this.currentIndex++;
            }
        },
        prevShipmentNotReady() {
            if (this.currentIndexNotReady > 0) {
                this.currentIndexNotReady--;
            }
        },
        nextShipmentNotReady() {
            if (this.currentIndexNotReady < this.shipmentsNotReady.length - 1) {
                this.currentIndexNotReady++;
            }
        },
        async refreshMap(){
            this.addressSuggestionLocation = false;
            this.addressSuggestionMarkerAdded == false;
            this.showAllManifestData = false;
            await this.getManifestShipmentData()
            if(this.manifestMapData.length > 0){
                if((this.manifestMapData[0].longitude != "")){
                    this.mapCreate();
                }
            }else{
                this.toggleAlertBox = true;
                this.alertMessage = "No manifest data available";
                this.selectedRoute = "";
            }
        },
        async showFullManifest(){
            this.showAllManifestData = true;
            await this.getManifestShipmentData()
            if(this.manifestMapData.length > 0){
                if((this.manifestMapData[0].longitude != "")){
                    this.mapCreate();
                }
            }else{
                this.toggleAlertBox = true;
                this.alertMessage = "No manifest data available";
                this.selectedRoute = "";
            }
        },
        async GetShipmentData(){
            try{
                let getShipment = await API.graphql({
                query:  `query getShipment{
                            getShipment(shipmentID: "${this.dragSelectedShipmentID}"){
                                owner
                                shipmentID
                                weight
                                currentKey
                                historyKey
                                inTransitKey
                                labelImage
                                accountNo
                                username
                                service
                                additionalServices
                                deliveryInstructions
                                serviceAddress{
                                    address{
                                        companyName
                                        address1
                                        address2
                                        city
                                        state
                                        zipCode
                                        attention
                                        phone
                                        latitude
                                        longitude
                                        relevance
                                        routeCode
                                    }
                                }
                                deliveryPickup{
                                    address{
                                        companyName
                                        address1
                                        address2
                                        city
                                        state
                                        zipCode
                                        attention
                                        phone
                                        latitude
                                        longitude
                                        relevance
                                        routeCode
                                    }
                                }
                                notify{
                                    delivery{
                                        email
                                        phone
                                    }
                                    nonDelivery{
                                        email
                                        phone
                                    }
                                }
                            }
                        }`,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                if(getShipment.data.getShipment == null){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting shipment"
                }else{
                    this.shipmentData = getShipment.data.getShipment;
                }
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting shipment";
                }
            }
        },
        async updateShipmentDataGeoCode(){
            this.loadingData = true;
            let input;

            let shipmentLatitude;
            let shipmentLongitude;
            let shipmentRelevance;

            shipmentLatitude = this.autoCompleteDataGeoCode[1];
            shipmentLongitude = this.autoCompleteDataGeoCode[0];
            shipmentRelevance = 1;
            console.log("UPDATE GEOCODE")
            console.log(this.shipmentData)
            console.log("IS DELIVERY: ", this.dragSelectedIsDelivery)
            console.log("IS PICKUP: ", this.dragSelectedIsPickup)
            if(this.dragSelectedIsDelivery){
                input = {
                    shipmentId: this.shipmentData.shipmentID,
                    deliveryCompanyName: this.shipmentData.serviceAddress.address.companyName,
                    deliveryAttention: this.shipmentData.serviceAddress.address.attention,
                    deliveryRouteCode: this.shipmentData.serviceAddress.address.routeCode,
                    deliveryAddress1: this.shipmentData.serviceAddress.address.address1,
                    deliveryAddress2: this.shipmentData.serviceAddress.address.address2,
                    deliveryCity: this.shipmentData.serviceAddress.address.city,
                    deliveryState: this.shipmentData.serviceAddress.address.state,
                    deliveryZipCode: this.shipmentData.serviceAddress.address.zipCode,
                    deliveryPhone: this.shipmentData.serviceAddress.address.phone,
                    deliveryLatitude: shipmentLatitude,
                    deliveryLongitude: shipmentLongitude,
                    deliveryAddressRelevance: shipmentRelevance,
                    pickupCompanyName: this.shipmentData.deliveryPickup.address.companyName,
                    pickupAttention: this.shipmentData.deliveryPickup.address.attention,
                    pickupRouteCode: this.shipmentData.deliveryPickup.address.routeCode,
                    pickupAddress1: this.shipmentData.deliveryPickup.address.address1,
                    pickupAddress2: this.shipmentData.deliveryPickup.address.address2,
                    pickupCity: this.shipmentData.deliveryPickup.address.city,
                    pickupState: this.shipmentData.deliveryPickup.address.state,
                    pickupZipCode: this.shipmentData.deliveryPickup.address.zipCode,
                    pickupPhone: this.shipmentData.deliveryPickup.address.phone,
                    pickupLatitude: this.shipmentData.deliveryPickup.address.latitude,
                    pickupLongitude: this.shipmentData.deliveryPickup.address.longitude,
                    pickupAddressRelevance: this.shipmentData.deliveryPickup.address.relevance,
                    addShipmentProcessStatusID: 64
                }

                console.log(input)
            }

            if(this.dragSelectedIsPickup){
                input = {
                    shipmentId: this.shipmentData.shipmentID,
                    deliveryCompanyName: this.shipmentData.serviceAddress.address.companyName,
                    deliveryAttention: this.shipmentData.serviceAddress.address.attention,
                    deliveryRouteCode: this.shipmentData.serviceAddress.address.routeCode,
                    deliveryAddress1: this.shipmentData.serviceAddress.address.address1,
                    deliveryAddress2: this.shipmentData.serviceAddress.address.address2,
                    deliveryCity: this.shipmentData.serviceAddress.address.city,
                    deliveryState: this.shipmentData.serviceAddress.address.state,
                    deliveryZipCode: this.shipmentData.serviceAddress.address.zipCode,
                    deliveryPhone: this.shipmentData.serviceAddress.address.phone,
                    deliveryLatitude: this.shipmentData.serviceAddress.address.latitude,
                    deliveryLongitude: this.shipmentData.serviceAddress.address.longitude,
                    deliveryAddressRelevance: this.shipmentData.serviceAddress.address.relevance,
                    pickupCompanyName: this.shipmentData.deliveryPickup.address.companyName,
                    pickupAttention: this.shipmentData.deliveryPickup.address.attention,
                    pickupRouteCode: this.shipmentData.deliveryPickup.address.routeCode,
                    pickupAddress1: this.shipmentData.deliveryPickup.address.address1,
                    pickupAddress2: this.shipmentData.deliveryPickup.address.address2,
                    pickupCity: this.shipmentData.deliveryPickup.address.city,
                    pickupState: this.shipmentData.deliveryPickup.address.state,
                    pickupZipCode: this.shipmentData.deliveryPickup.address.zipCode,
                    pickupPhone: this.shipmentData.deliveryPickup.address.phone,
                    pickupLatitude: shipmentLatitude,
                    pickupLongitude: shipmentLongitude,
                    pickupAddressRelevance: shipmentRelevance,
                    addShipmentProcessStatusID: 63
                }
            }

            console.log("INPUT: ", input)
            
            Object.keys(input).forEach(key => {
                if (input[key] === null) {
                    input[key] = ""
                }
            });

            try{
                await API.graphql({
                query: updateShipmentData,
                variables: {
                    input
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
                }).then((response)=>{
                    console.log(response)
                    this.showDragAddressSuggestion = false;
                    this.toggleAlertBox = true;
                    this.alertMessage = "Shipment has been updated."
                    this.loadingData = false;
                    setTimeout(() => {
                        const now = new Date();
                        now.setMinutes(now.getMinutes() + 1);
                        const formattedDateTime = now.getFullYear() + "-" +
                            String(now.getMonth() + 1).padStart(2, "0") + "-" +
                            String(now.getDate()).padStart(2, "0") + "T" +
                            String(now.getHours()).padStart(2, "0") + ":" +
                            String(now.getMinutes()).padStart(2, "0");

                        this.localDateTime = formattedDateTime;
                        this.refreshMap();
                    }, 2000);
                })
            }catch(e){
                if(e.errors[0].message){
                    this.alertMessage = e.errors[0].message;
                }else{
                    this.alertMessage = "Error updating shipment.";
                }
                this.toggleAlertBox = true;
                this.loadingData = false;
            }
        },
        async updateShipmentData(){
            this.loadingData = true;
            let input;

            let shipmentAddress1;
            let shipmentCity;
            let shipmentState;
            let shipmentZipCode;
            let shipmentLatitude;
            let shipmentLongitude;
            let shipmentRelevance;

            shipmentLatitude = this.autoCompleteDataFromText[0].Place.Geometry.Point[1];
            shipmentLongitude = this.autoCompleteDataFromText[0].Place.Geometry.Point[0];
            shipmentRelevance = this.autoCompleteDataFromText[0].Relevance;
            if((this.autoCompleteDataFromText[0].Place.AddressNumber != null) && (this.autoCompleteDataFromText[0].Place.Street != null)){
                shipmentAddress1 = this.autoCompleteDataFromText[0].Place.AddressNumber + " " + this.autoCompleteDataFromText[0].Place.Street;
            }else if((this.autoCompleteDataFromText[0].Place.AddressNumber != null) && (this.autoCompleteDataFromText[0].Place.Street == null)){
                shipmentAddress1 = this.autoCompleteDataFromText[0].Place.AddressNumber;
            }else if((this.autoCompleteDataFromText[0].Place.AddressNumber == null) && (this.autoCompleteDataFromText[0].Place.Street != null)){
                shipmentAddress1 = this.autoCompleteDataFromText[0].Place.Street;
            }
            shipmentCity = this.autoCompleteDataFromText[0].Place.Municipality;
            switch(this.autoCompleteDataFromText[0].Place.Region){
                case "Alabama":
                    shipmentState = "AL";
                    break;
                case "Alaska":
                    shipmentState = "AK";
                    break;
                case "Arizona":
                    shipmentState = "AZ";
                    break;
                case "Arkansas":
                    shipmentState = "AR";
                    break;
                case "California":
                    shipmentState = "CA";
                    break;
                case "Colorado":
                    shipmentState = "CO";
                    break;
                case "Connecticut":
                    shipmentState = "CT";
                    break;
                case "Florida":
                    shipmentState = "FL";
                    break;
                case "Georgia":
                    shipmentState = "GA";
                    break;
                case "Hawaii":
                    shipmentState = "HI";
                    break;
                case "Idaho":
                    shipmentState = "ID";
                    break;
                case "Illinois":
                    shipmentState = "IL";
                    break;
                case "Indiana":
                    shipmentState = "IN";
                    break;
                case "Iowa":
                    shipmentState = "IA";
                    break;
                case "Kansas":
                    shipmentState = "KS";
                    break;
                case "Kentucky":
                    shipmentState = "KY";
                    break;
                case "Louisiana":
                    shipmentState = "LA";
                    break;
                case "Michigan":
                    shipmentState = "MI";
                    break;
                case "Minnesota":
                    shipmentState = "MN";
                    break;
                case "Mississippi":
                    shipmentState = "MS";
                    break;
                case "Missouri":
                    shipmentState = "MO";
                    break;
                case "Montana":
                    shipmentState = "MT";
                    break;
                case "Nebraska":
                    shipmentState = "NE";
                    break;
                case "Nevada":
                    shipmentState = "NV";
                    break;
                case "New Mexico":
                    shipmentState = "NM";
                    break;
                case "North Carolina":
                    shipmentState = "NC";
                    break;
                case "North Dakota":
                    shipmentState = "ND";
                    break;
                case "Ohio":
                    shipmentState = "OH";
                    break;
                case "Oklahoma":
                    shipmentState = "OK";
                    break;
                case "Oregon":
                    shipmentState = "OR";
                    break;
                case "South Carolina":
                    shipmentState = "SC";
                    break;
                case "South Dakota":
                    shipmentState = "SD";
                    break;
                case "Tennessee":
                    shipmentState = "TN";
                    break;
                case "Texas":
                    shipmentState = "TX";
                    break;
                case "Utah":
                    shipmentState = "UT";
                    break;
                case "Vermont":
                    shipmentState = "VT";
                    break;
                case "Washington":
                    shipmentState = "WA";
                    break;
                case "West Virginia":
                    shipmentState = "WV";
                    break;
                case "Wisconsin":
                    shipmentState = "WI";
                    break;
                case "Wyoming":
                    shipmentState = "WY";
                    break;
                case "District of Columbia":
                    shipmentState = "DC";
                    break;
                case "Delaware":
                    shipmentState = "DE";
                    break;
                case "Massachusetts":
                    shipmentState = "MA";
                    break;
                case "Maryland":
                    shipmentState = "MD";
                    break;
                case "Maine":
                    shipmentState = "ME";
                    break;
                case "New Hampshire":
                    shipmentState = "NH";
                    break;
                case "New Jersey":
                    shipmentState = "NJ";
                    break;
                case "New York":
                    shipmentState = "NY";
                    break;
                case "Pennsylvania":
                    shipmentState = "PA";
                    break;
                case "Rhode Island":
                    shipmentState = "RI";
                    break;
                case "Virginia":
                    shipmentState = "VA";
                    break;
                default:
                    alert("Error with State Input")
            }
            shipmentZipCode = this.autoCompleteDataFromText[0].Place.PostalCode.substring(0, 5);

            if(this.dragSelectedIsDelivery){
                input = {
                    shipmentId: this.shipmentData.shipmentID,
                    deliveryCompanyName: this.shipmentData.serviceAddress.address.companyName,
                    deliveryAttention: this.shipmentData.serviceAddress.address.attention,
                    deliveryAddress1: shipmentAddress1,
                    deliveryAddress2: this.shipmentData.serviceAddress.address.address2,
                    deliveryCity: shipmentCity,
                    deliveryState: shipmentState,
                    deliveryZipCode: shipmentZipCode,
                    deliveryPhone: this.shipmentData.serviceAddress.address.phone,
                    deliveryLatitude: shipmentLatitude,
                    deliveryLongitude: shipmentLongitude,
                    deliveryAddressRelevance: shipmentRelevance,
                    pickupCompanyName: this.shipmentData.deliveryPickup.address.companyName,
                    pickupAttention: this.shipmentData.deliveryPickup.address.attention,
                    pickupAddress1: this.shipmentData.deliveryPickup.address.address1,
                    pickupAddress2: this.shipmentData.deliveryPickup.address.address2,
                    pickupCity: this.shipmentData.deliveryPickup.address.city,
                    pickupState: this.shipmentData.deliveryPickup.address.state,
                    pickupZipCode: this.shipmentData.deliveryPickup.address.zipCode,
                    pickupPhone: this.shipmentData.deliveryPickup.address.phone,
                    pickupLatitude: this.shipmentData.deliveryPickup.address.latitude,
                    pickupLongitude: this.shipmentData.deliveryPickup.address.longitude,
                    pickupAddressRelevance: this.shipmentData.deliveryPickup.address.relevance,
                    addShipmentProcessStatusID: 61
                }
            }

            if(this.dragSelectedIsPickup){
                input = {
                    shipmentId: this.shipmentData.shipmentID,
                    deliveryCompanyName: this.shipmentData.serviceAddress.address.companyName,
                    deliveryAttention: this.shipmentData.serviceAddress.address.attention,
                    deliveryAddress1: this.shipmentData.serviceAddress.address.address1,
                    deliveryAddress2: this.shipmentData.serviceAddress.address.address2,
                    deliveryCity: this.shipmentData.serviceAddress.address.city,
                    deliveryState: this.shipmentData.serviceAddress.address.state,
                    deliveryZipCode: this.shipmentData.serviceAddress.address.zipCode,
                    deliveryPhone: this.shipmentData.serviceAddress.address.phone,
                    deliveryLatitude: this.shipmentData.serviceAddress.address.latitude,
                    deliveryLongitude: this.shipmentData.serviceAddress.address.longitude,
                    deliveryAddressRelevance: this.shipmentData.serviceAddress.address.relevance,
                    pickupCompanyName: this.shipmentData.deliveryPickup.address.companyName,
                    pickupAttention: this.shipmentData.deliveryPickup.address.attention,
                    pickupAddress1: shipmentAddress1,
                    pickupAddress2: this.shipmentData.deliveryPickup.address.address2,
                    pickupCity: shipmentCity,
                    pickupState: shipmentState,
                    pickupZipCode: shipmentZipCode,
                    pickupPhone: this.shipmentData.deliveryPickup.address.phone,
                    pickupLatitude: shipmentLatitude,
                    pickupLongitude: shipmentLongitude,
                    pickupAddressRelevance: shipmentRelevance,
                    addShipmentProcessStatusID: 60
                }
            }
            
            Object.keys(input).forEach(key => {
                if (input[key] === null) {
                    input[key] = ""
                }
            });

            try{
                await API.graphql({
                query: updateShipmentData,
                variables: {
                    input
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
                }).then((response)=>{
                    console.log(response)
                    this.showDragAddressSuggestion = false;
                    this.toggleAlertBox = true;
                    this.alertMessage = "Shipment has been updated."
                    this.loadingData = false;
                })
            }catch(e){
                if(e.errors[0].message){
                    this.alertMessage = e.errors[0].message;
                }else{
                    this.alertMessage = "Error updating shipment.";
                }
                this.toggleAlertBox = true;
                this.loadingData = false;
            }
        },
        scrollToTop(){
            window.scrollTo(0,0);
        },
        trackShipment(){
            this.toggleTrackShipment = true;
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;

            if(this.refreshPage == true){
                window.location.reload();
            }
        },
        refreshOpenManifest(event){
            if(event){
                setTimeout(() => {
                    const now = new Date();
                    now.setMinutes(now.getMinutes() + 1);
                    const formattedDateTime = now.getFullYear() + "-" +
                        String(now.getMonth() + 1).padStart(2, "0") + "-" +
                        String(now.getDate()).padStart(2, "0") + "T" +
                        String(now.getHours()).padStart(2, "0") + ":" +
                        String(now.getMinutes()).padStart(2, "0");

                    this.localDateTime = formattedDateTime;
                    this.refreshMap();
                }, 2000);
            }
        },
        closeShipmentInfo(){
            this.toggleTrackShipment = false;
            this.popUpSelectedShipmentID = "";
            const now = new Date();
            now.setMinutes(now.getMinutes() + 1);
            const formattedDateTime = now.getFullYear() + "-" +
                String(now.getMonth() + 1).padStart(2, "0") + "-" +
                String(now.getDate()).padStart(2, "0") + "T" +
                String(now.getHours()).padStart(2, "0") + ":" +
                String(now.getMinutes()).padStart(2, "0");

            this.localDateTime = formattedDateTime;
            this.refreshMap();
        },
        closeAddressSuggestion(){
            this.showDragAddressSuggestion = false;
            this.dragSnappedToSuggestion = false;
        },
        clearAddressSuggestion(){
            this.addressSuggestionLocation = false;
            this.addressSuggestionMarkerAdded = false;
            this.dragSnappedToSuggestion = false;
            this.showDragAddressSuggestion = false;
            this.addressSuggestionGeoCode.latitude = 0;
            this.addressSuggestionGeoCode.longitude = 0;
            this.addressSuggestionGeoCode.address1 = "";
            this.addressSuggestionGeoCode.zipCode = "";
            this.addressSuggestionGeoCode.city = "";
            this.addressSuggestionGeoCode.state = "";
            this.mapCreate();
        },
        async optimiseManifest() {
            this.loadingOptimisation = true;
            let newDate = new Date(this.localDateTime)
            this.isoDateTime = newDate.toISOString();

            try {
                const response = await API.graphql({
                    query: `
                        mutation manifestOptimise {
                            manifestOptimise(input: {
                                routeCode: "${this.selectedRoute}",
                                manifestCutoffTime: "${this.isoDateTime}"
                            }) {
                                jobID
                                routeCode
                            }
                        }
                    `,
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });

                console.log(response);

                // Give AppSync a second to finish the mutation response
                setTimeout(() => {
                    window.location.reload();
                }, 1000);

            } catch (e) {
                console.log(e);

                let errorMessage = "Error optimising manifest data";

                if (e.errors?.length > 0) {
                    errorMessage = e.errors[0].message;
                } else if (e.message) {
                    errorMessage = e.message;
                }

                this.toggleAlertBox = true;
                this.alertMessage = errorMessage;
            } finally {
                this.loadingOptimisation = false;
            }
        },
        // async optimiseManifest(){
        //     this.loadingOptimisation = true;
        //     this.refreshPage = false;
        //     let mutationManifestOptimise = `mutation manifestOptimise{
        //         manifestOptimise(input: {routeCode: "${this.selectedRoute}"}) {
        //             jobID
        //             routeCode
        //         }
        //     }`;

        //     try {
        //         let response = await API.graphql({
        //             query: mutationManifestOptimise,
        //             variables: {routeCode: this.selectedRoute},
        //             authMode: "AMAZON_COGNITO_USER_POOLS",
        //         });
        //         console.log(response)
        //         const data = response.data.manifestOptimise;
        //         console.log(data)
        //         // this.toggleAlertBox = true;
        //         // this.alertMessage = "Manifest Optimized.";

        //         const success = await this.pollRouteOptimised(
        //             5,
        //             10000
        //         );

        //         if (success) {
        //             this.toggleAlertBox = true;
        //             this.alertMessage = "Manifest Optimized.";
        //         } else {
        //             this.toggleAlertBox = true;
        //             this.alertMessage =
        //             "This route is taking longer than expected to optimise. You can keep working—I'll catch up when it's ready.";
        //             this.refreshPage = true;
        //         }
        //     } catch (e) {
        //         console.log(e);

        //         let errorMessage = "Error optimising manifest data";

        //         if (e.errors?.length > 0) {
        //             errorMessage = e.errors[0].message;
        //         } else if (e.message) {
        //             errorMessage = e.message;
        //         }

        //         this.toggleAlertBox = true;
        //         this.alertMessage = errorMessage;
        //         this.refreshPage = true;
        //     } finally {
        //         this.loadingOptimisation = false;
        //     }
        // },
        async refreshManifestTable(event){
            if(event == true){
                await this.getManifestShipmentData()
            }
        },
        async closeShipmentInfoRefresh(event){
            if(event){
                const now = new Date();
                now.setMinutes(now.getMinutes() + 1);
                const formattedDateTime = now.getFullYear() + "-" +
                    String(now.getMonth() + 1).padStart(2, "0") + "-" +
                    String(now.getDate()).padStart(2, "0") + "T" +
                    String(now.getHours()).padStart(2, "0") + ":" +
                    String(now.getMinutes()).padStart(2, "0");

                this.localDateTime = formattedDateTime;
                this.refreshMap();
            }
        },
        async getManifestShipmentData() {
            this.manifestErrorMessage = "";
            if(!this.selectedRouteObject.openManifestAction){
                this.toggleAlertBox = true;
                this.alertMessage = "This route does not have a manifest action."
                this.manifestMapData = [];
                this.selectedRoute = "";
                this.selectedRouteObject = {};
                return;
            }

            let routeData = await this.getRouteData();
            if(routeData.manifestStatus !== "Dispatched" && routeData.manifestStatus !== "Optimization Failed"){
                this.toggleAlertBox = true;
                this.alertMessage = "Route status is invalid for open manifest."
                return;
            }

            if(routeData.manifestStatus === "Optimization Failed"){
                await this.getManifestWaypointData();
            }

            this.manifestMapData = [];
            this.shipmentsToReGeoCode = [];
            this.shipmentsNotReady = [];
            this.shipmentsNeedReGeoCode = false;
            this.shipmentsFoundNotReady = false;
            this.loadingManifestData = true;
            this.getManifestDataError = false;

            let newDate = new Date(this.localDateTime)
            this.isoDateTime = newDate.toISOString();

            let mutationQueryManifestShipment = `mutation queryManifestShipment{
                queryManifestShipment(input: {route: "${this.selectedRoute}", cutoff: "${this.isoDateTime}"}) {
                        shipmentID
                        route
                        status
                        longitude
                        latitude
                        isDelivery
                        isPriority
                        externalTrackingNumber
                        address {
                            companyName
                            address1
                            address2
                            city
                            state
                            zipCode
                            longitude
                            latitude
                            relevance
                        }
                    }
            }`;

            try {
                this.manifestMapData = [];

                let response = await API.graphql({
                    query: mutationQueryManifestShipment,
                    variables: {route: this.selectedRoute, cutoff: this.isoDateTime},
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });

                const data = response.data.queryManifestShipment;

                this.manifestMapData = data;
                console.log("Manifest Map Data: ", data);

                this.manifestMapData.forEach(shipment => {
                    console.log("SHIPMENT: ", shipment.externalTrackingNumber)
                    if (!shipment.externalTrackingNumber) {
                        this.getManifestDataError = true;
                        console.error(`Error: Shipment ID ${shipment.shipmentID} is missing an externalTrackingNumber.`);
                    }
                });

                if(this.manifestMapData.length == 0){
                    this.toggleAlertBox = true;
                    this.alertMessage = "No manifest data available";
                }

                this.shipmentsToReGeoCode = this.manifestMapData.filter(shipment => {
                    const relevance = parseFloat(shipment.address.relevance);
                    return isNaN(relevance) || relevance < 0.9;
                });

                this.shipmentsNotReady = this.manifestMapData.filter(shipment => {
                    const status = shipment.status;
                    return status == "NotReady";
                });

                this.shipmentsNeedReGeoCode = this.shipmentsToReGeoCode.length > 0;
                this.shipmentsFoundNotReady = this.shipmentsNotReady.length > 0;
                console.log("Filtered Shipments: ", this.shipmentsToReGeoCode);

                if(this.selectedRouteObject.openManifestAction == "Optimized"){
                    console.log("ROUTE NEEDS Optimized")
                    if(this.manifestMapData.length > 0){
                        console.log("MAP DATA FOUND")
                            this.mapCreate();
                    }
                }

                this.manifestTableFilterValue = "All";
                this.filterManifestMapData();
            } catch (e) {
                console.log(e);
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting manifest data";
            } finally {
                this.loadingManifestData = false;
            }
        },
        async pollRouteOptimised(attempts, intervalMs) {
            for (let i = 0; i < attempts; i++) {
                try {
                    const route = await this.getRouteData();
                    // Adjust these accessors to match your getRouteData() return shape
                    const manifestStatus = route?.manifestStatus;

                    // console.log(`poll #${i + 1} status:`, manifestStatus);

                    // Handle enum or string (British spelling you used earlier)
                    if (
                        manifestStatus === "Optimized"
                    ) {
                        this.$emit('toggleOptimizedManifestMap', {showOptmizedManifest: true})
                        return true;
                    }
                } catch (err) {
                    console.error("poll error:", err);
                    // even on error, wait and retry unless it's the last attempt
                }

                // sleep between tries (skip after final attempt)
                if (i < attempts - 1) {
                    await this.sleep(intervalMs);
                }
            }
            return false;
        },
        sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },
        async getRouteData(){
            let input = {
                input:{
                    routeCode: this.selectedRoute
                }
            }
            let queryRouteTable = `query getRoute{
            getRoute(routeCode: "${this.selectedRoute}") {
                    routeCode
                    openManifestAction
                    routeId
                    manifestStatus
                    manifestCutoffTime
                }
            }
            `

            try{
                let queryRouteTableData = await API.graphql({
                query:  queryRouteTable,
                variables: input,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                console.log("Route Data: ", queryRouteTableData.data.getRoute);
                this.routeDataForOptimize = queryRouteTableData.data.getRoute;
                return queryRouteTableData.data.getRoute;
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting route data"
                }
            }
        },
        async getLocationDataFromText() {
            this.autoCompleteDataFromText = [];

            if (this.autoCompleteData.length > 0 && this.autoCompleteData[0] && this.autoCompleteData[0].Place) {
                const placeLabel = this.autoCompleteData[0].Place.Label;

                if (placeLabel && placeLabel.length > 1) {
                    const credentials = await Auth.currentCredentials();

                    const locationClient = new Location({
                        credentials,
                        region: 'us-east-1'
                    });

                    const params = {
                        IndexName: "lrex-place",
                        Text: placeLabel,
                        FilterCountries: ["USA"],
                        BiasPosition: [-74.1724, 40.7357],
                        MaxResults: 5
                    };

                    locationClient.searchPlaceIndexForText(params, (err, data) => {
                        if (err) {
                            alert("Error with Location Services.");
                        }

                        if (data && data.Results && data.Results[0] && data.Results[0].Place) {
                            const resultPlace = data.Results[0].Place;
                            
                            if (resultPlace.AddressNumber || resultPlace.Street) {
                                this.autoCompleteDataFromText = data.Results;
                                this.showDragAddressSuggestion = true;
                                this.scrollToTop();
                                // this.GetShipmentData();
                            }
                        }
                    });
                }
            }
        },
        async getLocationData(lng, lat){
            this.autoCompleteData = []
            this.autoCompleteDataFromText = [];
            this.autoCompleteDataGeoCode = []
            const credentials = await Auth.currentCredentials();

            const locationClient = new Location({
                credentials,
                region: 'us-east-1'
            });

            const params = {
                IndexName: "lrex-place",
                Position: [lng, lat]
            };

                locationClient.searchPlaceIndexForPosition(params,(err,data)=>{
                    if(err){
                        console.log(err)
                        alert("Error with Location Services.")
                    }
                    if(data){
                        //Only suggest addresses with Street and AddressNumber Values
                        if(data.Results[0]){
                            this.autoCompleteDataGeoCode = data.Summary.Position;
                            this.showDragAddressSuggestion = true;
                            if(data.Results[0]?.Place?.AddressNumber || data.Results[0]?.Place?.Street){
                                this.autoCompleteData = data.Results;
                                //this.autoCompleteDataGeoCode = data.Summary.Position;
                                this.getLocationDataFromText();
                            }
                        }
                    }
                })
        },
        mapCreate: function() {
                this.addressSuggestionMarkerAdded = false;
                let mapData = [];
                let mapCenter = []
                this.shipmentMarkers = {};
                this.mapInstance = null;

                if ((this.shipmentsToReGeoCode.length > 0) && (this.showAllManifestData == false)) {
                    console.log("SHOW INVALID DATA")
                    mapData = this.shipmentsToReGeoCode;
                    mapCenter = [this.shipmentsToReGeoCode[0].longitude, this.shipmentsToReGeoCode[0].latitude]
                }else{
                    console.log("SHOW ALL DATA")
                    mapData = this.manifestMapData;
                    console.log("MAP DATA", mapData)
                    mapCenter = [this.manifestMapData[0].longitude, this.manifestMapData[0].latitude]
                }

                const map = new maplibregl.Map({
                    container: 'map',
                    style: 'LREXSite-Map',
                    center: mapCenter,
                    bearing: 64.8,
                    pitch: 10,
                    hash: true,
                    transformRequest: this.transformRequest
                });

                this.mapInstance = map;

                let markerArray = [];

                for (let i = 0; i < mapData.length; i++) {
                    const element = mapData[i];
                    console.log(element)
                    const popup = new maplibregl.Popup({
                            offset: 15,
                    }).setHTML(
                            `<div style="display: flex;
                            flex-direction: row;
                            align-items: center;
                            background-color: #e4e4e4;
                            border-radius: 999px;
                            padding: 5px;
                            width: -moz-fit-content;
                            width: fit-content;">
                            <svg style="width: 15px;
                            height: 15px;
                            padding-right: 5px;" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.67 328.54" data-v-13454f0d=""><g id="_Ñëîé_1" data-name="Ñëîé 1" data-v-13454f0d=""><g data-v-13454f0d=""><g data-v-13454f0d=""><polyline class="cls-2-alt" points="213.95 310.25 213.95 280.72 192.99 240.34 66.07 240.34 45.11 284.23 45.11 310.25" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="48.63" y1="284.23" x2="213.95" y2="284.23" data-v-13454f0d=""></line><polyline class="cls-2-alt" points="150.64 284.23 150.64 323.54 129.53 314.13 108.43 323.54 108.43 284.23" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="115.46" y1="240.34" x2="108.43" y2="284.23" data-v-13454f0d=""></line><line class="cls-2-alt" x1="150.64" y1="284.23" x2="143.6" y2="240.34" data-v-13454f0d=""></line></g><path class="cls-2" d="M5,263.23l4.07-31.12c1.49-11.39,9.48-20.87,20.45-24.26l41.72-12.89c4.68-1.45,9.78-.46,13.58,2.62h0c23.9,19.38,58.11,19.38,82.01,0h0c3.81-3.09,8.9-4.07,13.58-2.62l41.72,12.89c10.97,3.39,18.97,12.87,20.45,24.26l4.07,31.12" data-v-13454f0d=""></path><path class="cls-2" d="M179.67,133.69v1.49c0,17.17-9.99,32.77-25.58,39.95l-16.31,7.52c-7.79,3.59-16.76,3.59-24.54,0l-16.31-7.52c-15.59-7.18-25.58-22.78-25.58-39.95v-1.49" data-v-13454f0d=""></path><path class="cls-2" d="M66.66,77.38l2.08-34.12c.68-11.22,7.8-21.02,18.25-25.15l28.02-11.08c6.83-2.7,14.44-2.7,21.28,0l28.02,11.08c10.45,4.13,17.56,13.94,18.25,25.15l2.08,34.12" data-v-13454f0d=""></path><path class="cls-2" d="M182.17,75.94l-.69-.59c-31.61-27.16-78.16-27.68-110.37-1.23l-1.41,1.16c-5.33,4.37-6.62,12-3.03,17.89l8.7,14.27h0c30.19-23.72,72.69-23.72,102.89,0h0s3.95-8.06,7.32-14.94c2.77-5.66,1.38-12.46-3.4-16.56Z" data-v-13454f0d=""></path><path class="cls-2" d="M57.76,116.69l-.15,.9c-1.37,8.44,5.15,16.11,13.7,16.11h.03" data-v-13454f0d=""></path><path class="cls-2" d="M193.24,116.69l.15,.9c1.37,8.44-5.15,16.11-13.7,16.11h0" data-v-13454f0d=""></path></g></g></svg>
                            <h3 style="margin: 0">${element.shipmentID}</h3>
                            </div>
                            <h3 style="text-align: left">${element.address?.companyName}</h3>
                            <p style="text-align: left">${element.address?.address1} ${element.address?.address2 ? ' ' + element.address?.address2 : ''}, ${element.address?.city}, ${element.address?.state} ${element.address?.zipCode}</p>
                            <button class="update-shipment" id="shipment-update-button-${element.shipmentID}" style=" 
                                background-color: #32ccfe;
                                border: none;
                                padding: 5px 10px;
                                border-radius: 99px;
                                cursor: pointer;
                                color: white;">Update</button>
                            `
                    ).on('open', () => {
                        setTimeout(() => {
                            const popupEl = popup.getElement();
                            const btn = popupEl ? popupEl.querySelector(`#shipment-update-button-${element.shipmentID}`) : null;
                            if (btn) {
                                btn.onclick = (e) => {
                                    e.stopPropagation();
                                    this.popUpSelectedShipmentID = element.shipmentID;
                                    this.toggleTrackShipment = true;
                                    this.getShipment(this.popUpSelectedShipmentID);
                                };
                            }
                        }, 0);
                    });

                    let markerColor;
                    let deliveryColor = "#32ccfe";
                    let pickupColor = "#33f18a";
                    let priorityColor = "#fe804d";

                    const isDelivery = element?.isDelivery === true;
                    const isPriority = element?.isPriority === true;

                    markerColor = isDelivery
                    ? (isPriority ? priorityColor : deliveryColor)
                    : pickupColor;

                    // if(!element.stop){
                    //     continue;
                    // }
                    
                    // if(element?.isDelivery == true && element?.isPriority == false){
                    //     markerColor = deliveryColor;
                    // }else if(element?.isDelivery == false){
                    //     markerColor = pickupColor;
                    // }else if(element?.isDelivery == true && element?.isPriority == true){
                    //     markerColor = priorityColor;
                    // }

                    const svgString = `
                    <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" width="25" height="36" viewBox="0 0 24 32">
                        <g transform="translate(1.75, 28.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g>
                        <circle cx="12" cy="12" r="10" fill="#fff"/>
                        <path stroke="#000" stroke-width="1" fill="${markerColor}" d="M12,0c-6.6,0-12,5.4-12,12c0,10,12,20,12,20s12-10,12-20C24,5.4,18.6,0,12,0z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z"/>
                    </svg>
                    `;

                    // Create a new div element and set its innerHTML to the SVG string
                    const svgElement = document.createElement('div');
                    svgElement.innerHTML = svgString;
                    const longitude = parseFloat(element.longitude);
                    const latitude = parseFloat(element.latitude);

                    if (isNaN(longitude) || isNaN(latitude)) {
                        console.log("Invalid LAT AND LONG", element);
                        //Add offest to lat and long so markers do not overlap
                        element.latitude = 40.6926563606647 + .0001 + (Math.random() - 0.5) * 2 * .00009
                        element.longitude = -74.29343469110164 + .0001 + (Math.random() - 0.5) * 2 * .00009
                        console.log(element.latitude)
                        console.log(element.longitude)
                    }
                    //let offsetValue = .0001 + (Math.random() - 0.5) * 2 * .00009
                    let mapMarker = new maplibregl.Marker({
                        color: markerColor,
                        draggable: true,
                        element: svgElement
                    }).setLngLat([element.longitude, element.latitude])
                    .setPopup(popup)
                    .addTo(map);

                    mapMarker.getElement().addEventListener('click', () => {
                        this.getShipment(element.shipmentID);
                    }); 

                    mapMarker.on('dragstart', async()=> {
                        console.log("Drag Start")
                        console.log("ELEMENT: ", element)
                        this.dragSelectedShipmentID = element.shipmentID;
                        const isDelivery = element?.isDelivery === true;
                        const isPriority = element?.isPriority === true;

                        if (isDelivery && isPriority) {
                            markerColor = priorityColor;
                        } else if (isDelivery) {
                            markerColor = deliveryColor;
                        } else {
                            markerColor = pickupColor;
                        }

                        this.dragSelectedIsDelivery = isDelivery;
                        this.dragSelectedIsPickup   = !isDelivery;
                        // if(element.isDelivery == true && element.isPriority == false){
                        //     markerColor = deliveryColor;
                        //     this.dragSelectedIsDelivery = true;
                        //     this.dragSelectedIsPickup = false;
                        // }else if(element.isDelivery == false){
                        //     markerColor = pickupColor;
                        //     this.dragSelectedIsDelivery = false;
                        //     this.dragSelectedIsPickup = true;
                        // }else if(element.isDelivery == true && element.isPriority == true){
                        //     markerColor = priorityColor;
                        //     this.dragSelectedIsDelivery = true;
                        //     this.dragSelectedIsPickup = false;
                        // }
                    });

                    mapMarker.on('dragend', async()=> {
                        const lngLat = mapMarker.getLngLat();
                        popup.remove()

                        // If a black address-suggestion pin exists and the marker was dropped near it
                        // on screen, snap to the suggestion pin's coordinates instead of reverse-geocoding.
                        // Measured in screen pixels so it works at any zoom level.
                        if (this.addressSuggestionLocation) {
                            const suggestionLat = parseFloat(this.addressSuggestionGeoCode.latitude);
                            const suggestionLng = parseFloat(this.addressSuggestionGeoCode.longitude);

                            const droppedPoint = map.project([lngLat.lng, lngLat.lat]);
                            const suggestionPoint = map.project([suggestionLng, suggestionLat]);
                            const pixelDistance = Math.sqrt(
                                (droppedPoint.x - suggestionPoint.x) ** 2 +
                                (droppedPoint.y - suggestionPoint.y) ** 2
                            );

                            if (pixelDistance <= 50) {
                                // Snap the marker visually onto the suggestion pin
                                mapMarker.setLngLat([suggestionLng, suggestionLat]);
                                this.autoCompleteDataGeoCode = [suggestionLng, suggestionLat];
                                this.dragSnappedToSuggestion = true;
                                this.showDragAddressSuggestion = true;
                                await this.GetShipmentData();
                                return;
                            }
                        }

                        // Freeform drop — use the dropped coordinates directly, no geocode needed.
                        this.autoCompleteDataGeoCode = [lngLat.lng, lngLat.lat];
                        this.dragSnappedToSuggestion = false;
                        this.showDragAddressSuggestion = true;
                        await this.GetShipmentData();
                    });

                    console.log("MARKER ELEMENT: ", element)
                    this.shipmentMarkers[element.shipmentID] = mapMarker;

                    // map.on('click', () => {
                    //     console.log(element)
                    //     console.log(this.popUpSelectedShipmentID)
                    //     const button = document.getElementById(`shipment-update-button-${element.shipmentID}`);
                    //     console.log(button)
                    //     if (button) {
                    //         button.addEventListener('click', ()=> {
                    //             console.log("CLICKED")
                    //             this.toggleTrackShipment = true;
                    //             this.getShipment(this.popUpSelectedShipmentID);
                    //         });
                    //     }
                    // });

                    if(this.addressSuggestionLocation && (this.addressSuggestionMarkerAdded == false)){
                        const popup = new maplibregl.Popup({
                            offset: 15,
                        }).setHTML(
                                `<div style="display: flex;
                                flex-direction: row;
                                align-items: center;
                                background-color: #e4e4e4;
                                border-radius: 999px;
                                padding: 5px;
                                width: -moz-fit-content;
                                width: fit-content;">
                                <svg style="width: 15px;
                                height: 15px;
                                padding-right: 5px;" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.67 328.54" data-v-13454f0d=""><g id="_Ñëîé_1" data-name="Ñëîé 1" data-v-13454f0d=""><g data-v-13454f0d=""><g data-v-13454f0d=""><polyline class="cls-2-alt" points="213.95 310.25 213.95 280.72 192.99 240.34 66.07 240.34 45.11 284.23 45.11 310.25" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="48.63" y1="284.23" x2="213.95" y2="284.23" data-v-13454f0d=""></line><polyline class="cls-2-alt" points="150.64 284.23 150.64 323.54 129.53 314.13 108.43 323.54 108.43 284.23" data-v-13454f0d=""></polyline><line class="cls-2-alt" x1="115.46" y1="240.34" x2="108.43" y2="284.23" data-v-13454f0d=""></line><line class="cls-2-alt" x1="150.64" y1="284.23" x2="143.6" y2="240.34" data-v-13454f0d=""></line></g><path class="cls-2" d="M5,263.23l4.07-31.12c1.49-11.39,9.48-20.87,20.45-24.26l41.72-12.89c4.68-1.45,9.78-.46,13.58,2.62h0c23.9,19.38,58.11,19.38,82.01,0h0c3.81-3.09,8.9-4.07,13.58-2.62l41.72,12.89c10.97,3.39,18.97,12.87,20.45,24.26l4.07,31.12" data-v-13454f0d=""></path><path class="cls-2" d="M179.67,133.69v1.49c0,17.17-9.99,32.77-25.58,39.95l-16.31,7.52c-7.79,3.59-16.76,3.59-24.54,0l-16.31-7.52c-15.59-7.18-25.58-22.78-25.58-39.95v-1.49" data-v-13454f0d=""></path><path class="cls-2" d="M66.66,77.38l2.08-34.12c.68-11.22,7.8-21.02,18.25-25.15l28.02-11.08c6.83-2.7,14.44-2.7,21.28,0l28.02,11.08c10.45,4.13,17.56,13.94,18.25,25.15l2.08,34.12" data-v-13454f0d=""></path><path class="cls-2" d="M182.17,75.94l-.69-.59c-31.61-27.16-78.16-27.68-110.37-1.23l-1.41,1.16c-5.33,4.37-6.62,12-3.03,17.89l8.7,14.27h0c30.19-23.72,72.69-23.72,102.89,0h0s3.95-8.06,7.32-14.94c2.77-5.66,1.38-12.46-3.4-16.56Z" data-v-13454f0d=""></path><path class="cls-2" d="M57.76,116.69l-.15,.9c-1.37,8.44,5.15,16.11,13.7,16.11h.03" data-v-13454f0d=""></path><path class="cls-2" d="M193.24,116.69l.15,.9c1.37,8.44-5.15,16.11-13.7,16.11h0" data-v-13454f0d=""></path></g></g></svg>
                                <h3 style="margin: 0">Address Suggestion</h3>
                                </div>
                                <p style="text-align: left">${this.addressSuggestionGeoCode.address1}, ${this.addressSuggestionGeoCode.city}, ${this.addressSuggestionGeoCode.state} ${this.addressSuggestionGeoCode.zipCode}</p>
                                `
                        );
                        
                        let mapMarker = new maplibregl.Marker({
                            color: '#000',
                            draggable: false,
                            offset: [14, 0],
                        }).setLngLat([this.addressSuggestionGeoCode.longitude, this.addressSuggestionGeoCode.latitude])
                        .setPopup(popup)
                        .addTo(map);
                        markerArray.push(mapMarker)
                        this.addressSuggestionMarkerAdded = true;
                    }

                    markerArray.push(mapMarker)
                }

                let boundingArray = []
                for (let i = 0; i < markerArray.length; i++) {
                    const element = markerArray[i];
                    boundingArray.push([element['_lngLat'].lng, element['_lngLat'].lat])
                }

                map.on('load', () => {
                    const bounds = boundingArray.reduce((bounds, coord) => {
                        return bounds.extend(coord);
                    }, new maplibregl.LngLatBounds(boundingArray[0], boundingArray[0]));

                    map.fitBounds(bounds, { padding: 50 });
                    map.resize(); 
                });

                map.addControl(new maplibregl.NavigationControl());
                this.addressSuggestionMarkerAdded = false;
            },
            transformRequest: function (url, resourceType) {
                if (resourceType === 'Style' && !url.includes('://')) {
                    url = `https://maps.geo.${AWS.aws_project_region}.amazonaws.com/maps/v0/maps/${url}/style-descriptor`
                }
                if (url.includes('amazonaws.com')) {
                    return {
                        url: Signer.signUrl(url, {
                            access_key: this.credentials.accessKeyId,
                            secret_key: this.credentials.secretAccessKey,
                            session_token: this.credentials.sessionToken,
                        }),
                    }
                }
                return { url }
            },
            selectSearchResult(shipment) {
                this.shipmentSearchQuery = "";
                this.highlightShipment(shipment.shipmentID);
            },
            highlightShipment(shipmentID) {
                console.log("SHIPMENT ID:", shipmentID)
                console.log("SHIPMENT MARKERS: ", this.shipmentMarkers)
                const marker = this.shipmentMarkers?.[shipmentID];
                const map = this.mapInstance;

                console.log("MARKER: ", marker)

                if (!marker || !map) return;

                const lngLat = marker.getLngLat();

                map.flyTo({
                    center: [lngLat.lng, lngLat.lat],
                    zoom: 15,
                    essential: true
                });

                marker.togglePopup();

                // Optional: scale effect
                const el = marker.getElement();
                el.style.transition = 'transform 0.2s ease';
                el.style.transform += ' scale(1.5)';
                setTimeout(() => {
                    el.style.transform = el.style.transform.replace(' scale(1.5)', '');
                }, 1000);
            },
            getShipment(shipmentID){
                this.popUpSelectedShipmentID = shipmentID;
            },
            GetSelectedAddressData(selectedAddress){
            if((selectedAddress != false)){
                this.addressSuggestionLocation = true;
                this.addressSuggestionGeoCode.latitude = selectedAddress.latitude;
                this.addressSuggestionGeoCode.longitude = selectedAddress.longitude;
                this.addressSuggestionGeoCode.address1 = selectedAddress.address1;
                this.addressSuggestionGeoCode.zipCode = selectedAddress.zipCode;
                this.addressSuggestionGeoCode.city = selectedAddress.city;
                this.addressSuggestionGeoCode.state = selectedAddress.state;
                this.mapCreate();
            }else{
                this.addressSuggestionLocation = false;
                this.alertMessage = "The selected address is not valid.";
                this.addressSuggestionGeoCode.latitude = 0;
                this.addressSuggestionGeoCode.longitude = 0;
                this.addressSuggestionGeoCode.address1 = "";
                this.addressSuggestionGeoCode.zipCode = "";
                this.addressSuggestionGeoCode.city = "";
                this.addressSuggestionGeoCode.state = "";
            }
        }
    }
}
</script>

<style scoped>
/* @import 'node_modules/maplibre-gl/dist/maplibre-gl.css'; */
body { margin: 0; }
#map { 
    height: 60vh; 
    border-radius: 25px;
}

.map-search-wrapper {
    position: relative;
}

.map-search-box {
    position: absolute;
    top: 15px;
    left: 15px;
    z-index: 5;
    width: 320px;
    max-width: 70%;
}

.map-search-input {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 14px;
    font-size: 14px;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    outline: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    background-color: #fff;
}

.map-search-input:focus {
    border-color: #32ccfe;
}

.map-search-results {
    margin-top: 4px;
    background-color: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    max-height: 300px;
    overflow-y: auto;
}

.map-search-result {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid #f1f5f9;
    transition: background-color 0.15s ease;
}

.map-search-result:last-child {
    border-bottom: none;
}

.map-search-result:hover {
    background-color: #eef4fb;
}

.map-search-result-company {
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
}

.map-search-result-address {
    font-size: 12px;
    color: #475569;
}

.map-search-result-id {
    font-size: 11px;
    color: #94a3b8;
}

.map-search-no-result {
    padding: 10px 12px;
    font-size: 13px;
    color: #94a3b8;
}

.data-container-main{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
}

.table-container{
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    height: fit-content;
    flex-basis: 50%;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    display: flex;
    justify-content: center;
    /* align-items: center; */
    flex-direction: column;
}

.svg-container-outer{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.svg-container{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: fit-content;
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    /* flex-basis: 25%; */
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.route-table-container{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: fit-content;
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    flex-basis: 45%;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.svg-container h3{
    margin: 0;
}

/* .button-container button{
    background-color: #32ccfe;
    border: none;
    padding: 5px;
    border-radius: 99px;
    color: white;
    transition-duration: .25s;
    cursor: pointer;
}

.button-container button:hover{
    transition-duration: .25s;
    background-color: #2db3df;
} */
 input[type="checkbox"] {
    /* Add if not using autoprefixer */
    -webkit-appearance: none;
    /* Remove most all native input styles */
    appearance: none;
    /* For iOS < 15 */
    background-color: #fff;
    /* Not removed via appearance */
    margin: 0;
    cursor: pointer;

    font: inherit;
    color: #33f18a;
    width: 1.05em;
    height: 1.05em;
    border: 0.15em solid #33f18a;
    border-radius: 0.15em;
    /* transform: translateY(-0.075em); */

    display: grid;
    place-content: center;
    transition-duration: .5s;
}

input[type="checkbox"]:hover{
    background-color: #f3f3f3;
    transition-duration: .5s;
}

input[type="checkbox"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    /* Windows High Contrast Mode */
    background-color: CanvasText;
}

input[type="checkbox"]:checked::before {
    transform: scale(1);
}

.button-container-checkbox input{
    margin-left: 5px;
}

 .button-container-checkbox{
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
 }

 .optimize-button-container{
    display: flex;
    flex-direction: column;
 }

 .optimize-button-container-inner{
    display: flex;
    justify-content: flex-start;
 }

 .cutoff-date-container{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
 }

 .cutoff-date-container input {
	border: 1px solid #e2e2e2;
	padding: 5px;
	border-radius: 25px;
	box-shadow: rgba(0, 0, 0, .05) 0 5px 15px;
	outline: 0
}

 .manifest-button-container{
    display: flex;
    justify-content: flex-start;
 }

 .manifest-text-container{
    display: flex;
    justify-content: flex-start;
 }

 .manifest-text-container h3{
    margin-top: 5px;
    margin-bottom: 5px;
    background-color: #e4e4e4;
    padding: 5px;
    border-radius: 999px;
 }

 .manifest-text-container p{
    margin-top: 5px;
    margin-bottom: 5px;
 }

 .manifest-header{
    text-align: left;
    background-color: #e4e4e4;
    width: fit-content;
    padding: 5px;
    border-radius: 999px;
    margin-bottom: 5px !important;
    margin-top: 0;
 }

.refresh-button{
    margin-right: 5px;
    background-color: #32ccfe;
    border: none;
    padding: 5px;
    border-radius: 99px;
    color: white;
    transition-duration: .25s;
    cursor: pointer;
}

.refresh-button:hover{
    transition-duration: .25s;
    filter: brightness(0.95);
}

.show-manifest-button{
    background-color: #33f18a;
    border: none;
    padding: 5px;
    border-radius: 99px;
    color: white;
    transition-duration: .25s;
    cursor: pointer;
}

.show-manifest-button:hover{
    transition-duration: .25s;
    filter: brightness(0.95);
}

.optimize-manifest-button{
    background-color: #fe804d;
    margin-left: 15px;
    border: none;
    padding: 5px;
    border-radius: 99px;
    color: white;
    transition-duration: .25s;
    cursor: pointer;
}

.optimize-manifest-button:hover{
    transition-duration: .25s;
    filter: brightness(0.95);
}

.download-button{
	margin-bottom: 0;
	margin-top: 5px;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #f3f3f3;
	border: 1px solid #a0a0a0;
	transition-duration: .5s;
    cursor: pointer;
}

.download-button:hover{
    transition-duration: .25s;
    filter: brightness(0.95);
}

.input-container{
    width: 50%;
    margin-bottom: 10px;
    margin-top: 10px;
    margin-left: 5px;
}

.clear-address-button {
    margin-top: 8px;
    padding: 8px 14px;
    font-size: 13px;
    font-weight: 500;
    color: #475569;
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.clear-address-button:hover {
    background-color: #f1f5f9;
    border-color: #cbd5e1;
}

.maplibregl-map{
    margin-left: 5px;
    margin-right: 5px;
}

.svg-inner-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    max-width: 100px;
}

.svg-inner-container p{
    margin: 0;
}

.svg-inner-container svg{
    margin-left: 5px;
}

select{
    padding: 10px;
    font-size: 15px;
    border: 1px solid rgba(0,0,0,.336);
    border-radius: 15px;
    outline: none;
    margin-top: 5px;
    margin-bottom: 5px;
}

.update-shipment{
    background-color: #32ccfe;
    border: none;
    padding: 5px;
    border-radius: 99px;
    color: white;
}

.navigation-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  width: 100%;
}

.left-buttons button{
    background-color: #33f18a;
    color: #fff;
    border-radius: 6px;
    border: 0;
    cursor: pointer;
}

.left-buttons button:active{
    transform: scale(.97);
}

.left-buttons button:disabled{
    background-color: #bdbdbd;
    cursor: not-allowed;
}

.left-buttons {
  display: flex;
}

.left-buttons button {
  margin-right: 5px;
}

.right-button {
    margin-left: auto;
    background-color: #32ccfe;
    color: #fff;
    border-radius: 6px;
    border: 0;
    cursor: pointer;
}

.scrollable-container {
    margin-top: 5px;
    height: 80px;
    overflow-y: auto;
    width: 100%;
    background-color: #fff;
    border-radius: 5px;
    /* flex-basis: 25%; */
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    resize: vertical;
}

.scrollable-container-inner{
    background-color: #e4e4e4;
    /* max-height: 85px; */
    border-radius: 5px;
    padding-top: 5px;
    margin: 5px;
    text-align: left;
}

.scrollable-container-inner h3{
    background-color: #cecece !important;
    width: fit-content;
    padding: 10px 5px;
    border-radius: 99px;
    font-weight: bold;
    margin-left: 5px;
    margin-top: 0;
    transition-duration: .5s;
}

.scrollable-h3:hover{
    cursor: pointer;
    transition-duration: .5s;
}

.scrollable-container-inner p{
    margin-left: 5px !important;
}

.alert-container{
        width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center; /* 👈 vertical centering */

    position: fixed; /* 👈 stays centered on screen even when scrolling */
    top: 0;
    left: 0;

    z-index: 99;

    background: linear-gradient(
        rgba(0, 0, 0, 0.15) 0%,
        rgba(0, 0, 0, 0.15) 90%,
        rgba(236, 236, 236, 0.05) 100%
    );
}

.geo-card {
    background: #fff;
    padding: 20px 24px;
    margin-top: 5px;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0,0,0,0.15);
    /* width: 320px; */
    text-align: center;
}

.geo-title {
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 12px;
}

.geo-address {
    font-size: 13px;
    color: #475569;
    margin: 0 0 10px 0;
    text-align: left;
}

.geo-values {
    background: #f7f7f7;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 16px;
}

.geo-row {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    padding: 4px 0;
}

.label {
    color: #666;
}

.value {
    font-weight: 500;
    color: #222;
}

.geo-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

/* Buttons */
.btn {
    padding: 10px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    font-size: 14px;
    transition: 0.2s;
}

.btn.primary {
    background: #33f18a;
    color: white;
}

.btn.primary:hover {
    background: #2ed97b;
}

.btn.secondary {
    background: #eee;
    color: #333;
}

.btn.secondary:hover {
    background: #ddd;
}

    .inner-container{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .main-button-blue-white{
        margin: 5px;
        padding-top: 4px;
        padding-bottom: 4px;
    }

    .text-container{
        background-color: #fff;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.475);
        border-radius: 15px;
        width: 30%;
        z-index: 99;
        text-align: center;
        position: absolute;
        top: 15%;
        animation: animate-alert .5s ease;
        max-height: 70vh;
        overflow-y: auto;

    }

    .header-container{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background-color: #e4e4e4;
        border-radius: 999px;
        padding: 5px;
        width: -moz-fit-content;
        width: fit-content;
        text-align: center;
    }

    .title-header-container{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        width: -moz-fit-content;
        width: fit-content;
        text-align: center;
        margin: 5px;
        background-color: #fff;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.475);
        border-radius: 15px;
        padding: 10px;
    }

    .title-header-container h3{
        background-color: #e4e4e4;
        border-radius: 999px;
        padding: 5px;
        margin-bottom: 5px;
        margin-top: 5px;
    }

    .title-header-container p{
        margin: 0;
    }

    .header-outer-container{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 5px;
    }

    .cancel-button{
        margin: 5px;
        background-color: #fe804d;
        color: #fff;
        border-radius: 15px;
        padding: 5px 10px;
        border: none;
        cursor: pointer;
        transition-duration: .25s;
    }

    .cancel-button:hover{
        background-color: #d26a41;
        transition-duration: .25s;
    }

    .update-button{
        margin: 5px;
        background-color: #32ccfe;
        color: #fff;
        border-radius: 15px;
        padding: 5px 10px;
        border: none;
        cursor: pointer;
        transition-duration: .25s;
    }

    .update-button:hover{
        background-color: #2cb4e1;
        transition-duration: .25s;
    }

    .manifest-error-content {
        animation: manifestErrorPulse 2s infinite;
    }

    @keyframes manifestErrorPulse {
        0%, 100% {
            box-shadow: 0 2px 8px rgba(220, 53, 69, 0.15);
        }
        50% {
            box-shadow: 0 2px 18px rgba(220, 53, 69, 0.4);
        }
    }

    .manifest-error-container {
        width: 30%;
        display: flex;
        justify-content: center;
        margin: 25px 10px;
    }

    .manifest-error-content {
        display: flex;
        align-items: center;
        gap: 12px;

        width: 100%;
        max-width: 900px;

        background: #fff5f5;
        border: 2px solid #dc3545;
        border-left: 8px solid #dc3545;

        border-radius: 8px;
        padding: 16px 20px;

        box-shadow: 0 2px 8px rgba(220, 53, 69, 0.15);
    }

    .manifest-error-icon {
        font-size: 24px;
        flex-shrink: 0;
    }

    .manifest-error-content h3 {
        margin: 0;
        color: #b02a37;
        font-size: 18px;
        font-weight: 700;

        /* Prevent long messages from breaking layout */
        max-height: 120px;
        overflow-y: auto;
        word-break: break-word;
        white-space: normal;
    }

    @keyframes animate-alert {
        from{
            top: 10%;
            opacity: 0;
        }
        to{
            top: 15%;
            opacity: 1;
        }
    }

    @media screen and (max-width: 1000px) {
        .text-container{
            width: 70%;
        }

        .svg-container-outer{
            flex-direction: column;
            font-size: 10px;
        }

        .manifest-error-container {
            width: 80%;
            margin: 10px;
        }
    }
</style>